import { ActionContext } from 'vuex';

import { TBusinessTipState } from '@/modules/mpk/store/mpkBusinessTip/types';

import { MpkEventShortDto } from '../types/ratingMpk';
import { MPK_RATING_ACTIONS_NAME, MPK_RATING_MUTATIONS_NAME } from './name';
import { TMpkActivityParams, TMpkRatingBaseParams } from './type';

import links from '@/utils/links';
import request from '@/utils/request';

export async function getMpkActivityDetail(
  context: ActionContext<TBusinessTipState, unknown>,
  params: TMpkActivityParams,
) {
  return request(
    context,
    {
      url: links.mpkRating.getMpkActivityDetail,
      mutate: MPK_RATING_MUTATIONS_NAME.setMpkActivityDetail,
      name: MPK_RATING_ACTIONS_NAME.getMpkActivityDetail,
    },
    params,
  );
}

export async function getLastTwoEventsForExecutiveDiscipline(
  context: ActionContext<MpkEventShortDto[], unknown>,
  params: TMpkRatingBaseParams,
) {
  return request(
    context,
    {
      url: links.mpkRating.getLastTwoEventsForExecutiveDiscipline,
      mutate: MPK_RATING_MUTATIONS_NAME.setLastTwoEventsForExecutiveDiscipline,
      name: MPK_RATING_ACTIONS_NAME.getLastTwoEventsForExecutiveDiscipline,
    },
    params,
  );
}
